import {
  GET_DIAGNOSES,
  GET_CONSULTATION,
  UPDATE_DOCTORS_DATA,
  SET_REMINDER,
  SET_REMINDER_STATUS,
  CHANGE_IMAGE_STATUS,
} from "js/redux/type.js";

import { axiosAuth } from "js/config/axios-instance";

export function getDiagnoses(pageNo, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosAuth.get(
        process.env.REACT_APP_API_BASE_URL + `/cases?page=${pageNo}`,
      );
      await dispatch({
        type: GET_DIAGNOSES,
        payload: response.data,
      });
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function getDiagnosisByUUID(uuid, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosAuth.get(
        process.env.REACT_APP_API_BASE_URL + `/cases/${uuid}`,
      );
      await dispatch({
        type: GET_CONSULTATION,
        payload: response.data,
      });
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function uploadPicture(data, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      formData.append("image", data);
      let response = await axiosAuth.post(
        process.env.REACT_APP_API_BASE_URL + "/upload",
        formData,
      );
      succcessCallback && succcessCallback();
      return response;
    } catch (e) {
      console.error("Error:", e);
      //   await dispatch({
      //     // type: AUTHENTICATION_FAILED
      //   });
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function reUploadImages(data, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      await axiosAuth.post(
        process.env.REACT_APP_API_BASE_URL + "/images",
        data,
      );
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function followup(data, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      await axiosAuth.post(
        process.env.REACT_APP_API_BASE_URL + "/second",
        data,
      );
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function removeCaseImage(data, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      await axiosAuth.post(
        process.env.REACT_APP_API_BASE_URL + "/remove-image",
        data,
      );
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function getDoctor(uuid, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosAuth.get(
        process.env.REACT_APP_API_BASE_URL + `/doctors/${uuid}`,
      );
      await dispatch({
        type: UPDATE_DOCTORS_DATA,
        payload: response.data,
      });
      console.log("Doctor data:", response.data);
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function setReminder(uuid, succcessCallback, errorCallback) {
  return async function (dispatch) {
    console.log("setting reminder");
    try {
      let response = await axiosAuth.post(
        process.env.REACT_APP_API_BASE_URL + `/set-reminder/${uuid}`,
      );
      await dispatch({
        type: SET_REMINDER,
        payload: {
          appointment_reminder: true,
        },
      });
      console.log("Doctor data:", response.data);
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function changeReminderState(data, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      await dispatch({
        type: SET_REMINDER_STATUS,
        payload: data,
      });
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}

export function changeImageVisibility(data, succcessCallback, errorCallback) {
  return async function (dispatch) {
    try {
      await dispatch({
        type: CHANGE_IMAGE_STATUS,
        payload: data,
      });
      succcessCallback && succcessCallback();
    } catch (e) {
      console.error("Error:", e);
      errorCallback && errorCallback((e, (_) => _.response.data.message));
    }
  };
}
